var styleDataHash = "896596d3";
const injectCss = () => {
  var css = `@charset "UTF-8";.glob_fontElementMap,.v5JHt{font-family:var(--ricos-font-family,unset)}.QwiFv{align-items:center;color:var(--ricos-settings-text-color,#000);display:flex;font-family:var(--ricos-settings-text-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,メイリオ,meiryo,"ヒラギノ角ゴ pro w3","hiragino kaku gothic pro",sans-serif);font-size:14px;justify-content:center}[dir] .QwiFv{background:transparent;border:0;cursor:pointer;padding:4px}[dir] .QwiFv:hover:not([disabled]){background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.06)}.QwiFv.Si1ZM{color:var(--ricos-settings-text-color,var(--ricos-action-color-fallback,#116dff));fill:var(--ricos-settings-text-color,var(--ricos-action-color-fallback,#116dff))}[dir] .QwiFv.Si1ZM{background-color:rgba(var(--ricos-action-color-fallback-tuple,2,97,255),.1)}.QwiFv.Si1ZM svg{fill:var(--ricos-settings-icons-color,currentColor);color:var(--ricos-settings-icons-color,currentColor)}.QwiFv.oWA1-{opacity:.4}[dir] .QwiFv.oWA1-{cursor:default}[dir] .QwiFv._3V4uR:not(.Si1ZM):hover{background-color:unset}.QwiFv:focus{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}.HCfqg{align-items:center;display:flex;gap:8px;height:20px;justify-content:center;min-width:20px;position:relative;width:max-content}.HCfqg.ISoDP{height:32px;width:32px}.e1GGS{align-items:center;display:flex;gap:8px;height:20px;justify-content:center;min-width:20px;position:relative;width:max-content}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var ToolbarButton_default = {
  "fontElementMap": "v5JHt",
  "toolbarButtonWrapper": "QwiFv",
  "active": "Si1ZM",
  "disabled": "oWA1-",
  "mobileToolbarButtonWrapper": "_3V4uR",
  "toolbarButton": "HCfqg",
  "mobileToolbarButton": "ISoDP",
  "iconTextWrapper": "e1GGS"
};
export {
  ToolbarButton_default as default,
  injectCss
};
//# sourceMappingURL=ToolbarButton-scss.js.map
